import React from 'react';
import './css/HomePage.css';
import botImage from './image/TweakBot.png'; // Убедитесь, что путь к изображению правильный

const HomePage = () => {
  return (
    <div className="homepage">
      <div className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h1>
              <span className="title-line">TweakBot</span>
            </h1>
            <p className="hero-description">
              Бот для развлечений, музыки, а также модерации вашего сервера!
            </p>
            <div className="button-group">
              <a href="https://discord.com/oauth2/authorize?client_id=1009421126776127548">
                <button className="primary-button">Добавить в Discord</button>
              </a>
              <a href="#commands">
                <button className="secondary-button">Посмотреть команды</button>
              </a>
            </div>
          </div>
          <div className="hero-image-container">
            <img src={botImage} alt="TweakBot" className="hero-image"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;